import React, { useState, useEffect } from 'react';

const About = () => {
  return <div>
    <h1>About</h1>
    <p>This is Landon's website :D</p>
  </div>
}
export default About;